<template>
    <div style="background:#fff;max-width:800px;margin:0px auto;position:relative;border:3px solid rgb(239, 239, 239);padding:20px;">
        <table>
            <tbody>
                <tr v-for="row in 5" :key="row">
                    <td v-for="cell in 8" :key="`${row}${cell}`">
                        <input
                                type="checkbox"
                                :id="`c${row}${cell}`"
                                :value="(row - 1) * 8 + cell"
                                v-model="answer"
                                @change="onChange"
                        >
                        <label :for="`c${row}${cell}`"></label>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                answer: []
            }
        },
        methods: {
            onChange () {
                let value = this.result
                this.$emit('input', value)
            }
        },
        computed: {
            result () {
                return [].concat(this.answer)
            }
        }
    }
</script>

<style scoped>
    table {
        width: 100%;
        margin: 0 auto;
        border: 1px solid #000;
        border-collapse: collapse;
    }
    tr {
        border: 1px solid #000;
    }
    td {
        border: 1px solid #000;
        padding: 20px 20px;
        text-align: center;
        position: relative;
        user-select: none;
    }
    label {
        position: absolute;
        left: 0;
        width: 100%;
        top: 0;
        height: 100%;
        cursor: pointer;
    }

    input {
        opacity: 0;
    }

    input:checked ~ label {
        background: red;
    }
</style>








